import getClientConfigValue from "../getClientConfigValue";

const getIsProduction = () =>
  getClientConfigValue("CRITEO_IS_PRODUCTION") === "true";

export default getIsProduction;
